<template>
  <blogs/>
</template>

<script>
  import Blogs from "./Blogs";

  export default {
    name: "NewsType",
    data() {
      return {
        type: "News"
      }
    },
    components: {Blogs},

  }
</script>

<style scoped>

</style>
